<div
  class="news-card"
  [class.news-card--clickable]="news.externalUrl"
  [attr.aria-labelledby]="news.objectID + '-title'"
  [attr.aria-describedby]="news.objectID + '-desc'"
>
  <img
    *ngIf="news.image"
    class="news-card__img"
    [src]="imageUrl | imaginarySrc: 1:224"
    [srcset]="imageUrl | imaginarySrc: 4:224"
    [alt]=""
    loading="lazy"
  />
  <h3 role="heading" [id]="news.objectID + '-title'" class="news-card__title" ellipsis>{{ news.title }}</h3>
  <div class="news-card__excerpt" [id]="news.objectID + '-desc'" ellipsis>
    <p [innerHTML]="news.subTitle"></p>
  </div>
  <p class="more" *ngIf="news.externalUrl">
    En savoir plus
    <mat-icon [svgIcon]="news.externalUrl | buttonLinkIcon" role="presentation"></mat-icon>
  </p>
</div>
